import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { IdentifiedFieldIssue } from '../IFITrackerContext/types'
import { getReport } from '../utils/getReport'

export function usePayItems(): PayItemsOptions<IdentifiedFieldIssue> {
  return {
    onFilter: (globalId, record) =>
      getReport(record)
        ?.payItemNoGeometries?.map(({ globalId }) => globalId)
        ?.includes(globalId) ?? false,
  }
}
